// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"disclaimer-28sZ8","disclaimer__inner":"disclaimer__inner-1tEER","disclaimer__icon":"disclaimer__icon-VAthV","disclaimer__paragraph":"disclaimer__paragraph-293Fy"};